export const ISO_COUNTRY_CODES = [
    'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ',
    'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS',
    'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN',
    'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE',
    'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF',
    'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM',
    'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM',
    'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC',
    'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK',
    'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA',
    'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG',
    'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW',
    'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS',
    'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO',
    'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI',
    'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'
];

export const getLocalizedCountryList = (locale: string) => {
    let displayNames: Intl.DisplayNames | null = null;
    try {
        displayNames = new Intl.DisplayNames([locale], { type: 'region' });
    } catch (e) {
        displayNames = null;
    }

    return ISO_COUNTRY_CODES.map((code) => {
        const name = displayNames ? displayNames.of(code) || code : code;
        return { code, name };
    }).sort((a, b) => a.name.localeCompare(b.name, locale));
};

export const sanitizeNipPL = (nip: string): string => {
    if (!nip) return '';
    let clean = nip.trim().replace(/[\s-]/g, '');
    if (clean.toUpperCase().startsWith('PL')) {
        clean = clean.substring(2);
    }
    return clean;
};

export const isValidNipPL = (nip: string): boolean => {
    const cleanNip = sanitizeNipPL(nip);
    if (!/^\d{10}$/.test(cleanNip)) {
        return false;
    }
    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const sum = weights.reduce((acc, weight, idx) => acc + parseInt(cleanNip[idx], 10) * weight, 0);
    const checksum = sum % 11;
    return checksum === parseInt(cleanNip[9], 10);
};

export const normalizeCountryCode = (country: string | null | undefined): string => {
    if (!country || !country.trim()) return '';
    const trimmed = country.trim().toUpperCase();
    if (ISO_COUNTRY_CODES.includes(trimmed)) {
        return trimmed;
    }
    if (['POLSKA', 'POLAND', 'POL'].includes(trimmed)) {
        return 'PL';
    }
    return '';
};
